import { axiosClient } from './AxiosClient'
import axios from 'axios'
import { baseURL } from '../Network/Config'

function SendMassage(
    sender,
    message,
    channel,
    deptIds,
    compIds,
    userIds,
    schedule_date,
    callback,
    errorCallback
){
    let url = baseURL + "/inbox/admin/create" 

    var formData = new FormData()
    formData.append("sender", sender)
    formData.append("message", message)
    formData.append("channel", channel)
    formData.append("deptIds", deptIds)
    formData.append("compIds", compIds)
    formData.append("userIds", userIds)
    formData.append("schedule_date", schedule_date)

    console.log(formData)

    axiosClient.post(url, formData)
    .then((response)=>{
        callback(response.data)
        console.log("complete")
    })
    .catch((error)=>{
        console.log(error.response)
        console.log("error")
        errorCallback(error)
    })
}
export { SendMassage }